{
  "INBOX": {
    "LIST": {
      "404": "V tejto skupine nie sú žiadne aktívne upozornenia.",
      "TITLE": "Moja schránka",
      "DISPLAY_DROPDOWN": "Zobrazenie",
      "LOADING": "Načítavajú sa upozornenia",
      "NO_NOTIFICATIONS": "Žiadne upozornenia",
      "NOTE": "Upozornenia zo všetkých odoberaných schránok",
      "NO_MESSAGES_AVAILABLE": "Jejda! Nepodarilo sa načítať správy",
      "SNOOZED_UNTIL": "Odložené do",
      "SNOOZED_UNTIL_TOMORROW": "Odložené do zajtra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odložené do ďalšieho týždňa"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Odložiť upozornenie",
      "DELETE": "Odstrániť upozornenie",
      "BACK": "Späť"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Boli ste zmienení v konverzácii",
      "CONVERSATION_CREATION": "Vytvorená nová konverzácia",
      "CONVERSATION_ASSIGNMENT": "Bola vám priradená konverzácia",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová správa v priradenej konverzácii",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nová správa v konverzácii, ktorej sa zúčastňujete",
      "SLA_MISSED_FIRST_RESPONSE": "SLA cieľ prvej odpovede bol prekročený pre konverzáciu",
      "SLA_MISSED_NEXT_RESPONSE": "SLA cieľ ďalšej odpovede bol prekročený pre konverzáciu",
      "SLA_MISSED_RESOLUTION": "SLA cieľ vyriešenia bol prekročený pre konverzáciu"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Zmienené",
      "CONVERSATION_ASSIGNMENT": "Priradené vám",
      "CONVERSATION_CREATION": "Nová konverzácia",
      "SLA_MISSED_FIRST_RESPONSE": "Porušenie SLA",
      "SLA_MISSED_NEXT_RESPONSE": "Porušenie SLA",
      "SLA_MISSED_RESOLUTION": "Porušenie SLA",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nová správa",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová správa",
      "SNOOZED_UNTIL": "Odložené na {time}",
      "SNOOZED_ENDS": "Odloženie skončilo",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová správa"
    },
    "NO_CONTENT": "Žiaden obsah nie je k dispozícii",
    "MENU_ITEM": {
      "MARK_AS_READ": "Označiť ako prečítané",
      "MARK_AS_UNREAD": "Označiť ako neprečítané",
      "SNOOZE": "Odložiť",
      "DELETE": "Vymazať",
      "MARK_ALL_READ": "Označiť všetky ako prečítané",
      "DELETE_ALL": "Odstrániť všetky",
      "DELETE_ALL_READ": "Odstrániť všetky prečítané"
    },
    "DISPLAY_MENU": {
      "SORT": "Zoradiť",
      "DISPLAY": "Zobrazenie:",
      "SORT_OPTIONS": {
        "NEWEST": "Najnovšie",
        "OLDEST": "Najstaršie",
        "PRIORITY": "Priorita"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Odložené",
        "READ": "Prečítané",
        "LABELS": "Štítky",
        "CONVERSATION_ID": "ID konverzácie"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Upozornenie označené ako prečítané",
      "MARK_AS_UNREAD": "Upozornenie označené ako neprečítané",
      "SNOOZE": "Upozornenie odložené",
      "DELETE": "Upozornenie odstránené",
      "MARK_ALL_READ": "Všetky upozornenia označené ako prečítané",
      "DELETE_ALL": "Všetky upozornenia odstránené",
      "DELETE_ALL_READ": "Všetky prečítané upozornenia odstránené"
    },
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Odchádzajúci hovor - Spojený",
      "OUTBOUND_FAILED": "Odchádzajúci hovor - Neúspešný",
      "INBOUND_MISSED": "Prichádzajúci hovor - Zmeškaný",
      "INBOUND_UNANSWERED_MISSED": "Prichádzajúci hovor - Zmeškaný nezodpovedaný",
      "INBOUND_AGENT": "Prichádzajúci hovor - Odpovedaný agentom",
      "INBOUND_IVR": "Prichádzajúci hovor - Odpovedaný IVR",
      "DEFAULT": "Telefónny hovor"
    }
  }
}
